import Fuse from 'fuse.js'

export const getSearchConfiguration = (allJournals) => {
    return new Fuse(allJournals, {
        keys: [{ name: 'eventName', weight: 2 }, 'eventIdentifier', 'locationAddress','locationCity', 'locationCountry', 'locationTitle', 'locationZip', 'date'],
        threshold: 0.3,
        ignoreLocation: true,
    })
}
